import {getResidentTestId} from "../../helper";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {StyledDropdownMenuItem} from "./styles";

export const ViewAdmissionDropdownItem = ({
  admission,
  label = "View Admission",
}: {
  admission: AdmissionFromSearch;
  label?: string;
}) => (
  <StyledDropdownMenuItem
    asLink
    to={`/admin/workflows/${admission.id}`}
    target="_blank"
    testId={getResidentTestId(admission, "view")}
  >
    {label}
  </StyledDropdownMenuItem>
);
